/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type SubscriptionPackage,
    SubscriptionPackageFromJSON,
    SubscriptionPackageToJSON,
} from '../models/SubscriptionPackage';

export interface ProjectSubscriptionApiListProjectSubscriptionsRequest {
    projectId: string;
}

/**
 * 
 */
export class ProjectSubscriptionApi extends runtime.BaseAPI {

    /**
     * Creates request options for listProjectSubscriptions without sending the request
     */
    async listProjectSubscriptionsRequestOpts(requestParameters: ProjectSubscriptionApiListProjectSubscriptionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectSubscriptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/subscriptions`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of available subscription packages.
     */
    async listProjectSubscriptionsRaw(requestParameters: ProjectSubscriptionApiListProjectSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackage>>> {
        const requestOptions = await this.listProjectSubscriptionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageFromJSON));
    }

    /**
     * Returns list of available subscription packages.
     */
    async listProjectSubscriptions(requestParameters: ProjectSubscriptionApiListProjectSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackage>> {
        const response = await this.listProjectSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
